<template>
  <div class="my-progress-bar">
    <div class="m-progress-bar-content">
      <div class="m-progress-bar" :style="{ width: bar + '%' }"></div>
    </div>
    <span class="m-progress-bar-w">{{ bar }}%</span>
  </div>
</template>

<script>
export default {
  name: "MyProgressBar",
  data() {
    return {};
  },
  props: {
    bar: 0,
  },
};
</script>

<style>
.my-progress-bar {
  display: flex;
  align-items: center;
  justify-content: center;
}
.m-progress-bar-content {
  width: 2rem;
  height: 0.1rem;
  background: #fbc5c5;
  border-radius: 0.2rem;
  position: relative;
}
.m-progress-bar {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  border-radius: 0.2rem;
  background: #f00;
}
.m-progress-bar-w {
  margin-left: 0.1rem;
}
</style>


// WEBPACK FOOTER //
// src/pages/mobile/components/MyProgressBar/index.vue